import { goRequest } from '../utils/httpClientTs';
import {
  ElfLoanRecurringPaymentInfo,
  FinanceElfLoanDetailResponse,
  FinanceElfLoansListParams,
  FinanceElfLoansListResponse,
} from '../types/financeElfLoans';

export const getFinanceElfLoansList = async (
  params: FinanceElfLoansListParams
): Promise<FinanceElfLoansListResponse> => {
  let url = `/finance/elf-loans?page_size=${params.page_size}&page=${params.page}`;

  if (params.search) {
    url += `&search=${encodeURIComponent(params.search)}`;
  }
  if (params.order_by) {
    url += `&order_by=${encodeURIComponent(params.order_by)}`;
  }
  if (params.order) {
    url += `&order=${encodeURIComponent(params.order)}`;
  }

  return goRequest<FinanceElfLoansListResponse>({
    url: url,
    method: 'GET',
  });
};

export const getFinanceElfLoanDetail = async (
  id: string
): Promise<FinanceElfLoanDetailResponse> => {
  return goRequest<FinanceElfLoanDetailResponse>({
    url: `/finance/elf-loans/${encodeURIComponent(id)}`,
    method: 'GET',
  });
};

export const patchFinanceElfLoanRecurringAmount = async (
  id: string,
  amount: number
): Promise<ElfLoanRecurringPaymentInfo> => {
  return goRequest<ElfLoanRecurringPaymentInfo>({
    url: `/finance/elf-loans/${encodeURIComponent(id)}/recurring-amount`,
    method: 'PATCH',
    data: { amount },
  });
};
